(() => {
  'use strict';
  const region = document.querySelector('[data-finiks-personalisation]');
  if (!region) return;
  const allowed = () => {
    const state = window.FiniksConsent?.getState?.();
    return Boolean(state?.preferencesAllowed && state?.personalisation && state?.behaviour);
  };
  const guidanceFor = summary => {
    const labels = new Set((summary?.estimates || []).map(item => item.label));
    if (labels.has('Considering a purchase')) return { label: 'Review your bag', detail: 'Your bag shows current availability and checkout details.', href: '/cart' };
    if (labels.has('Comparing product options')) return { label: 'Compare available options', detail: 'Use live product pages to compare variants, prices and specifications.', href: '/collections/all' };
    if (labels.has('Seeking store guidance')) return { label: 'Review delivery and returns', detail: 'Destination-specific options are confirmed at checkout.', href: '/policies/shipping-policy' };
    if (labels.has('Exploring the catalogue')) return { label: 'Continue exploring', detail: 'Browse the current collection and refine with store search.', href: '/collections/all' };
    return null;
  };
  const render = () => {
    if (!allowed()) { region.hidden = true; region.replaceChildren(); return; }
    const guidance = guidanceFor(window.FiniksIntent?.getSummary?.());
    if (!guidance) { region.hidden = true; region.replaceChildren(); return; }
    const title = document.createElement('strong');
    title.textContent = 'Finiks suggestion';
    const detail = document.createElement('p');
    detail.textContent = guidance.detail;
    const link = document.createElement('a');
    link.href = guidance.href;
    link.textContent = guidance.label;
    region.replaceChildren(title, detail, link);
    region.hidden = false;
  };
  document.addEventListener('finiks:intent-updated', render);
  document.addEventListener('finiks:consent-changed', render);
  render();
})();
